export class ListIngestionPipelineHistoryFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actorId",
            "baseName": "actorId",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "PipelineHistoryKindFilters",
            "format": ""
        },
        {
            "name": "recordedAt",
            "baseName": "recordedAt",
            "type": "DateRangeFilter",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelineHistoryFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
